import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GetRace, GetStartlist, FormatVOdds, FormatPOdds, DisplayTrackName, StartClassName, FriendlySpeed } from './HelperService';

export const Result = () => {
    const params = useParams();
    const [list, setList] = useState([]);
    const [race, setRace] = useState();
    const [loading, setloading] = useState(true);

    useEffect(() => {
        GetRace(
            params.date,
            params.trackId,
            params.raceNumber,
            data => {
                setRace(data.results[0]);
                GetStartlist(
                    data.results[0].id,
                    list => {
                        setList(list);
                        setloading(false);
                    },
                    err => {
                        console.log(err);
                    }
                );
            },
            error => {
                console.log(error);
            });
    }, [params]);


    const formatPlacement = (start) => {
        if (start.dsq)
            return "d";
        if (start.scratched)
            return "s";
        return start.placement;
    }

    function renderList() {
        if (race.has_result) {
            let resultList = list.starts.sort((a, b) => a.finishing_position - b.finishing_position).slice(0, 3);
            return (
                <div className='startList'>
                    <div className='heading clearfix'>
                        <div className='leg'>{DisplayTrackName(race)}</div>
                        <div className='method'>{race.base_dist}<span className='lower'>m</span> {race.start_method}</div>
                    </div>
                    {resultList.map((start) => (

                        <div key={start.start_number} className={StartClassName(start, list.starts.length)}>
                            <div className='horse'>{formatPlacement(start)}. {start.start_number} {start.horse.name}</div>
                            <div className='driver'>{start.driver}</div>
                            {/* <div className='distance'>{start.scratched ? "" : start.distance}</div>  */}
                            {/* <div className={start.placement === 1 ? 'odds winner' : 'odds'}>{FormatVOdds(start, true)}</div>
                            <div className='odds'>{FormatPOdds(start)}</div> */}
                        </div>
                    ))}
                    <div className='oddsPanel'>
                        <div>Vinnare: <span className='oddsValue'>{FormatVOdds(resultList[0], true)}</span></div>
                        <div>Plats: <span className='oddsValue'>{FormatPOdds(resultList[0])}-{FormatPOdds(resultList[1])}-{FormatPOdds(resultList[2])}</span></div>
                        <div>Tid: <span className='oddsValue'>{FriendlySpeed(resultList[0].speed)}</span></div>
                    </div>
                </div>
            )
        }

        return (
            <div className='startList'>
                <div className='heading clearfix'>
                    <div className='leg'>{DisplayTrackName(race)}</div>
                    <div className='method'>{race.start_method}</div>
                </div>
                <div className="start clearfix">
                    <div className='horse'>Resultat ej tillgängligt</div>
                </div>
            </div>
        )
    }

    let content = loading
        ? <></>
        : renderList()

    return (
        <>
            {content}
        </>
    )
}
